import { ThemedStyleFn } from '~src/hooks/useStyles';

export const styleFn: ThemedStyleFn = (theme) => ({
  container: {
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '20px',
    minHeight: '30px',
    minWidth: '30px',
    outline: 'none',
  },
  containerWithHover: {
    cursor: 'pointer',
    ':hover': {
      backgroundColor: theme.colors.primaryLight,
    },
  },
  badgeContainer: {
    position: 'absolute',
    right: '-2px',
    bottom: '-2px',
    borderRadius: '50%',
    fontSize: '9px',
    height: '11px',
    width: '11px',
    backgroundColor: theme.colors.primaryLight,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 600,
  },
  containerDisabled: {
    cursor: 'not-allowed',
  },
  blue: {
    color: theme.colors.primary,
  },
  red: {
    color: theme.colors.red,
  },
  green: {
    color: theme.colors.green,
  },
  darkGray: {
    color: theme.colors.darkGray,
  },
  yellow: {
    color: theme.colors.yellow,
  },
  white: {
    color: theme.colors.white,
  },
  lightBlue: {
    color: theme.colors.lightBlue,
  },
  tenderBlue: {
    color: theme.colors.tenderBlue,
  },
});
